var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":""}},on),[_vm._v(" mdi-information ")])]}}])},[_c('span',[_vm._v("Sistema e código utilizados na integração com o Jira")])])}
var staticRenderFns = []

export { render, staticRenderFns }